import React from 'react';
import { Box, Typography, Container, Grid, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import InfiniteMathCarousel from '../Math/InfiniteMathCarousel';

export default function About() {
    const navigate = useNavigate();

    return (
        <Box id="about" sx={{ bgcolor: '#0a0a0a', py: 12, borderTop: '1px solid #222' }}>
            <Container maxWidth="lg">
                <Grid container spacing={6} alignItems="center">
                    <Grid item xs={24} md={8}>
                            <Box
                                sx={{
                                    '& .infinite-math-carousel': {
                                        minHeight: { xs: 400, md: 450 },
                                        height: { xs: 400, md: 450 },
                                        overflow: 'hidden',
                                    },
                                    '& .math-slide-content': {
                                        minHeight: '100%',
                                        boxSizing: 'border-box',
                                    },
                                }}
                            >
                                <InfiniteMathCarousel />
                            </Box>
                    </Grid>

                    <Grid item xs={24} md={4}>
                        <Typography variant="overline" sx={{ color: '#2cbb5d', fontWeight: 'bold', letterSpacing: 2 }}>
                            About
                        </Typography>
                        <Typography variant="h3" fontWeight={800} color="#ffffff" sx={{ mb: 3, mt: 1 }}>
                            Tools for evolving systems
                        </Typography>
                        <Typography variant="body1" color="#a1a1aa" sx={{ lineHeight: 1.8, fontSize: '1.1rem', mb: 2 }}>
                            Evolve<sup>X</sup> brings biology, engineering, gaming, and art together in one place.
                        </Typography>
                        <Typography variant="body1" color="#a1a1aa" sx={{ lineHeight: 1.8, fontSize: '1.1rem', mb: 3 }}>
                            Upload Python agents, run live sims, and compare how they behave.
                        </Typography>
                        <Button
                            variant="outlined"
                            onClick={() => navigate('/about')}
                            sx={{ borderColor: '#333', color: '#2cbb5d', textTransform: 'none' }}
                        >
                            Meet the team
                        </Button>
                    </Grid>
                </Grid>
            </Container>
        </Box>
    );
}
